import { PropsWithChildren } from 'react';
import { AnalyticsDataPageScreenType } from 'src/types/googleAnalyticsEvents';
import { TrackedPage } from 'src/components';
import { DetailedSourceLanguageResponse } from 'src/types/languagesDomain';
import { LanguagePairProvider } from 'src/context/languagePair';
import { TargetLanguagesProvider } from 'src/context/targetLanguages';
import { SeoPageDescription } from '../SeoPageDescription';
import { PageLayout } from '../PageLayout';
import { PageUrlMeta } from '../PageUrlMeta';

export type PageContainerProps = PropsWithChildren<{
  'data-testid': string;
  languagePair: DetailedSourceLanguageResponse;
  targetLanguages: DetailedSourceLanguageResponse[];
  urlMeta: Parameters<typeof PageUrlMeta>[0];
  contentMeta: {
    contentType: AnalyticsDataPageScreenType;
    contentName: string;
    pageTitle: string;
    pageDescription: string;
  };
  customLayout?: true;
}>;

export const PageContainer = ({
  'data-testid': dataTestId,
  languagePair,
  targetLanguages,
  urlMeta,
  contentMeta,
  customLayout,
  children,
}: PageContainerProps) => (
  <LanguagePairProvider languagePair={languagePair}>
    <TargetLanguagesProvider targetLanguages={targetLanguages}>
      <PageUrlMeta {...urlMeta} />
      <SeoPageDescription title={contentMeta.pageTitle} description={contentMeta.pageDescription} />

      <TrackedPage pageName={contentMeta.contentName} pageType={contentMeta.contentType}>
        <div data-testid={dataTestId}>
          {customLayout ? (
            children
          ) : (
            <PageLayout alternateLinks={urlMeta.alternateLinks}>{children}</PageLayout>
          )}
        </div>
      </TrackedPage>
    </TargetLanguagesProvider>
  </LanguagePairProvider>
);
